import { ID, LineItem, Lot, LotChanges } from 'types';
import { numericalSort } from '@utils/sorting';

import { mergeLots } from './emptyLot';

const filterDeletedLot = (lot: Lot) => !lot._destroy;

const filterDeletedLineItem = (lineItem: LineItem) => !lineItem._destroy;

const filterAndSort = (lineItems?: LineItem[], filter?: boolean): LineItem[] => {
  if (!lineItems?.length) return [];
  return filter ? lineItems.filter(filterDeletedLineItem) : lineItems;
};

export const applyChanges = ({ lots, lotChanges, sort = true, filter = true }: {
  filter?: boolean;
  lotChanges?: Record<ID, LotChanges>;
  lots?: Lot[];
  sort?: boolean;
}): Lot[] => {
  if (lots === undefined) return [];
  let result: Lot[] = mergeLots({ lotChanges, lots });

  if (!result.length) return [];
  if (filter) result = result.filter(filterDeletedLot);

  if (!result.length) return [];
  if (sort) result.sort((a, b) => numericalSort(a, b, 'sno'));

  return result.map((lot: Lot) => ({
    ...lot,
    line_items: filterAndSort(lot.line_items, filter)
  }));
};
